
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorMapIec as ObiCursorMapIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-map-iec.js';
 
 
 

 
 export const ObiCursorMapIec = createComponent({
   react: React,
   tagName: 'obi-cursor-map-iec',
   elementClass: ObiCursorMapIecElement,
   events: {
     
   }
  });
 
 